import React from "react";

import { TablePagination } from "@trendmicro/react-paginations";

import { DEFAULT_PAGINATION_RECORDS_ARRAY } from "./PaginationConstants";
// Be sure to include styles at some point, probably during your bootstraping
import "@trendmicro/react-paginations/dist/react-paginations.css";
import "./Pagination.scss";
import { Strings } from "../../Translations/i18n";

class Pagination extends React.Component {
  pageLengthRenderer = ({ pageLength }) => {
    return (
      <span>
        {pageLength} {Strings("perPage")}
      </span>
    );
  };
  render() {
    let totalRecords =
      this.props.recordsPerPage &&
      this.props.numberOfPages &&
      this.props.recordsPerPage * this.props.numberOfPages;

    return (
      <div className="pagination">
        <TablePagination
          type="full"
          page={this.props.activePage}
          pageLength={this.props.recordsPerPage}
          pageLengthMenu={DEFAULT_PAGINATION_RECORDS_ARRAY}
          totalRecords={totalRecords}
          onPageChange={({ page, pageLength }) => {
            this.props.onPageChange({ page, pageLength });
          }}
          dropup={this.props.dropup}
          prevPageRenderer={() => <i className="fa fa-angle-left" />}
          nextPageRenderer={() => <i className="fa fa-angle-right" />}
          pageLengthRenderer={this.pageLengthRenderer}
        />
      </div>
    );
  }
}

export default Pagination;
